export default __webpack_public_path__ + "static/media/spaceman.dafa57a8.png";